<template>
    <div class="cal-card">
        <v-progress-linear v-if="loading" indeterminate color="accent" height="2" class="cal-progress" />
        <month-calendar :events="daysWithRoutines" readonly flat dense :month.sync="pickerDate" />
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import MonthCalendar from "@/components/common/MonthCalendar";

export default {
    name: "CalendarStudent",
    components: {MonthCalendar},
    props: {
        studentId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            pickerDate: null,
            monthsCache: {},
            inflight: {},
            currentMonthRoutines: [],
        }
    },
    computed: {
        ...mapState(['routinesStudent']),
    },
    async mounted() {
        const vm = this
        let date = vm.$moment().format('YYYY-MM-DD')
        await vm.loadRoutines(date)
    },
    methods: {
        ...mapActions(['fetchRoutinesStudent']),
        daysWithRoutines(date) {
            const vm = this
            let result = []
            vm.currentMonthRoutines.forEach(routine => {
                if (routine.rawDate.full === date) {
                    routine?.advance?.post ?
                        result.push('#009966') :
                        result.push('#E85C5C')
                }
            })
            return result
        },
        async loadRoutines(date) {
            const vm = this
            const monthKey = vm.$moment(date).format('YYYY-MM')
            if (vm.monthsCache[monthKey]) {
                vm.currentMonthRoutines = vm.monthsCache[monthKey]
                return
            }
            if (vm.inflight[monthKey]) {
                await vm.inflight[monthKey]
                vm.currentMonthRoutines = vm.monthsCache[monthKey] || []
                return
            }
            const request = vm.withLoading(async () => {
                await vm.fetchRoutinesStudent({studentId: vm.studentId, date: date})
                const docs = [...vm.routinesStudent]
                vm.monthsCache[monthKey] = docs
                vm.currentMonthRoutines = docs
            })
            vm.inflight[monthKey] = request
            try {
                await request
            } finally {
                delete vm.inflight[monthKey]
            }
        }
    },
    watch: {
        async pickerDate(val) {
            let vm = this
            let date = vm.$moment(val).format('YYYY-MM-DD')
            vm.loadRoutines(date)
        },
    }
}
</script>

<style scoped>
.cal-card {
    position: relative;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    padding: 6px;
    overflow: hidden;
}

.cal-progress {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
}
</style>
